/**
 * GENERATED — DO NOT EDIT.
 *
 * Source: src/assets/i18n/**\/*.json
 * Regenerate with: npm run i18n:types
 */

/** Content hash of each locale file, keyed as Transloco requests it ('es', 'master/es'). */
export const TRANSLATION_HASHES: Readonly<Record<string, string>> = {
  'en': 'a26099a7a6',
  'es': 'cc6d0258a5',
  'routing/en': '11453f7616',
  'routing/es': '278e36689f',
};
